var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"levels"},[_vm._l((_vm.numLevelList),function(item,index){return [_c('img',{key:index,attrs:{"src":_vm.numIcons[item],"width":_vm.widthPercentage,"height":_vm.numLevelList.length === 1 ? '100%' : 'auto'}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }